(function () {
  const sectionSelectors = document.querySelectorAll(
    ".shop-location-map-wrapper"
  );

  // Detect touch / coarse pointer to differentiate tap vs click behavior.
  const IS_TOUCH = (function () {
    return (
      "ontouchstart" in window ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      (window.matchMedia && window.matchMedia("(pointer: coarse)").matches)
    );
  })();

  if (!sectionSelectors.length) return;

  // Global callback for Google Maps async loading
  window.initGoogleMaps = function() {
    sectionSelectors.forEach(initSection);
  };

  // Only initialize if Google Maps is already loaded, otherwise wait for callback
  if (window.google && window.google.maps) {
    sectionSelectors.forEach(initSection);
  }

  function initSection(wrapper) {
    const raw = wrapper.getAttribute("data-locations") || "";
    let locations = parseCsv(raw);

    locations = locations
      .map((l, idx) => normalizeLocation(l, idx))
      .map((l) => ({ ...l, slug: l.slug || slugify(l.displayName || l.name) }));

    const prefectureSelect = wrapper.querySelector(".shop-location-map-select");
    const sectionId = wrapper.getAttribute("data-section-id");
    const listEl = wrapper.querySelector("#LocationList-" + sectionId);
    const mapContainer = wrapper.querySelector(".shop-location-map-canvas");
    const initialPref = wrapper.getAttribute("data-initial-prefecture");
    const shareBase =
      wrapper.getAttribute("data-share-url") || window.location.pathname;
    const urlScope = wrapper.getAttribute("data-url-scope") || "default";
    const isPrimarySection = urlScope === "page.shop-location";
    let grouped = groupBy(locations, "prefecture");
    const prefectureLabels = buildPrefectureLabels(locations);
    
    // Marker color configuration (read from section settings or use defaults)
    const MARKER_COLOR_DEFAULT = wrapper.dataset.markerDefaultColor || "#EA4335";
    const MARKER_COLOR_HIGHLIGHT = wrapper.dataset.markerHighlightColor || "#FF8C00";
    const LEGEND_HIGHLIGHT_LABEL =
      wrapper.dataset.legendHighlightLabel || "お試し可能取扱店舗";

    const isImageMarkerValue = (value) => {
      return (
        value &&
        (value.startsWith("http://") ||
          value.startsWith("https://") ||
          value.startsWith("data:"))
      );
    };

    // Standard prefecture order: Hokkaido at top, Okinawa at bottom.
    const PREFECTURE_ORDER = [
      "北海道",
      "青森県",
      "岩手県",
      "宮城県",
      "秋田県",
      "山形県",
      "福島県",
      "茨城県",
      "栃木県",
      "群馬県",
      "埼玉県",
      "千葉県",
      "東京都",
      "神奈川県",
      "新潟県",
      "富山県",
      "石川県",
      "福井県",
      "山梨県",
      "長野県",
      "岐阜県",
      "静岡県",
      "愛知県",
      "三重県",
      "滋賀県",
      "京都府",
      "大阪府",
      "兵庫県",
      "奈良県",
      "和歌山県",
      "鳥取県",
      "島根県",
      "岡山県",
      "広島県",
      "山口県",
      "徳島県",
      "香川県",
      "愛媛県",
      "高知県",
      "福岡県",
      "佐賀県",
      "長崎県",
      "熊本県",
      "大分県",
      "宮崎県",
      "鹿児島県",
      "沖縄県",
    ];

    const prefectures = Object.keys(grouped).sort((a, b) => {
      const labelA = prefectureLabels[a] || a || "";
      const labelB = prefectureLabels[b] || b || "";

      // Explicitly push "N/A" style entries to the bottom.
      const isNaA = String(labelA).toUpperCase() === "N/A";
      const isNaB = String(labelB).toUpperCase() === "N/A";
      if (isNaA && !isNaB) return 1;
      if (!isNaA && isNaB) return -1;

      const idxA = PREFECTURE_ORDER.indexOf(labelA);
      const idxB = PREFECTURE_ORDER.indexOf(labelB);
      const knownA = idxA !== -1;
      const knownB = idxB !== -1;

      // Known prefectures come before unknown ones.
      if (knownA && !knownB) return -1;
      if (!knownA && knownB) return 1;
      if (knownA && knownB) return idxA - idxB;

      // For unknown labels, fall back to Japanese locale alphabetical.
      return String(labelA).localeCompare(String(labelB), "ja");
    });

    // Populate prefecture select (placeholder initially selected in markup).
    populatePrefectureSelect(
      prefectureSelect,
      prefectures,
      null,
      prefectureLabels
    );
    // Keep fullscreen layout until user selects a prefecture.
    requestAnimationFrame(() => {
      wrapper.classList.add("is-mounted");
    });

    let map;
    let markers = [];
    let activePref = null;
    let activeLocationId = null;
    let tooltipOverlay = null; // custom tooltip overlay instance
    const urlParams = new URLSearchParams(window.location.search);
    
    // Determine marker appearance (color or image URL)
    const getMarkerStyle = (loc) => {
      const markerValue = String(loc.marker_url || loc.marker || "").trim();

      // Check if it's an image URL (http/https or data URI)
      if (isImageMarkerValue(markerValue)) {
        return { type: "image", url: markerValue };
      }

      // Check for 0/1 color flag
      if (markerValue === "1") {
        return { type: "color", color: MARKER_COLOR_HIGHLIGHT };
      }

      // Default: red pin (0, empty, or any other value)
      return { type: "color", color: MARKER_COLOR_DEFAULT };
    };

    // Read URL parameters with scope-specific fallback
    const prefParam = isPrimarySection ? 
      urlParams.get("pref") : 
      (urlParams.get(`pref-${urlScope}`) || urlParams.get("pref"));
    
    if (prefParam) activePref = prefParam;
    // If no prefecture specified via URL, default to initial prefecture (e.g. tokyo)
    // so that Tokyo-related shops are shown on first load.
    if (!activePref && initialPref && (grouped[initialPref] || []).length) {
      activePref = initialPref;
    }
    
    const locSlugParam = isPrimarySection ? 
      urlParams.get("loc") : 
      (urlParams.get(`loc-${urlScope}`) || urlParams.get("loc"));
    
    // Initialize map if Google Maps is available
    if (window.google && window.google.maps) {
      initMap();
    } else {
      mapContainer.innerHTML =
        '<div class="shop-location-map-empty">Map unavailable (API key missing).</div>';
    }
    // List renders after user selects prefecture (initially empty)
    renderList();

    // If a prefecture is active (via URL param or initial setting), reflect it and hide placeholder.
    if (activePref) {
      const opt = prefectureSelect.querySelector(
        `option[value="${activePref}"]`
      );
      if (opt) {
        prefectureSelect.value = activePref;
        const placeholder = prefectureSelect.querySelector('option[value=""]');
        if (placeholder) {
          placeholder.disabled = true;
          placeholder.hidden = true;
        }
        wrapper.classList.remove("is-initial-fullscreen");
        wrapper.classList.add("has-selection");
      }
    }

    prefectureSelect.addEventListener("change", () => {
      const val = prefectureSelect.value;
      if (!val) return; // placeholder still selected
      activePref = val;
      wrapper.classList.remove("is-initial-fullscreen");
      wrapper.classList.add("has-selection");
      // disable & hide placeholder after first real selection
      const placeholder = prefectureSelect.querySelector('option[value=""]');
      if (placeholder) {
        placeholder.disabled = true;
        placeholder.hidden = true;
      }
      updateURL();
      render();
    });

    function initMap() {
      // Determine initial center:
      // 1. If a prefecture preselected via URL param, first location of that prefecture.
      // 2. Else use initial prefecture setting (default tokyo).
      // 3. Else attempt to find a location whose prefecture label is Tokyo in JP.
      // 4. Else fallback to first location in full list.
      const centerPref = activePref || initialPref;
      let centerLoc = firstLocationOf(centerPref);
      if (!centerLoc) {
        centerLoc =
          locations.find((l) => l.prefecture_label === "東京都") ||
          locations[0];
      }
      if (!centerLoc) {
        mapContainer.innerHTML =
          '<div class="shop-location-map-empty">No locations configured.</div>';
        return;
      }
      map = new google.maps.Map(mapContainer, {
        center: { lat: +centerLoc.lat, lng: +centerLoc.lng },
        zoom: 11,
        clickableIcons: false,
        mapTypeControl: false,
      });
      // Initialize custom tooltip overlay once map exists
      tooltipOverlay = createTooltipOverlay(map);
      map.addListener("bounds_changed", () => {
        if (tooltipOverlay) tooltipOverlay.updatePosition();
      });
      render();
      if (locSlugParam) {
        const target = locations.find((l) => l.slug === locSlugParam);
        if (target) focusLocation(target);
      }
    }

    function render() {
      renderList();
      if (map) renderMarkers();
    }

    function renderList() {
      if (!activePref) {
        listEl.innerHTML = "";
        // Also remove toggle button if exists
        const existingBtn = wrapper.querySelector('.shop-location-map-toggle-btn');
        if (existingBtn) existingBtn.remove();
        return; // wait until user selects
      }

      const subset = grouped[activePref] || [];

      if (!subset.length) {
        listEl.innerHTML =
          '<li class="shop-location-map-empty">No locations for this prefecture.</li>';
        // Remove toggle button
        const existingBtn = wrapper.querySelector('.shop-location-map-toggle-btn');
        if (existingBtn) existingBtn.remove();
        return;
      }

      listEl.innerHTML = subset
        .map((l) => {
          const displayName = l.displayName || l.name || "";
          const targetUrl = hasUrl(l) ? l.url : "#";
          const openLink = `<button type="button" class="shop-location-map-open" data-open-id="${l.id}" data-url="${escapeHtml(targetUrl)}" aria-label="Open store page for ${escapeHtml(displayName)}">Open</button>`;
          const markerValue = String(l.marker_url || l.marker || "").trim();
          const showHighlightTag =
            markerValue === "1" && !isImageMarkerValue(markerValue);
          const highlightTag = showHighlightTag
            ? `<div class="shop-location-map-item-tag"><span class="shop-location-map-swatch" aria-hidden="true"></span><span>${escapeHtml(LEGEND_HIGHLIGHT_LABEL)}</span></div>`
            : "";
          return `<li class="shop-location-map-list-item" data-location-id="${l.id}" data-slug="${l.slug}" tabindex="0">\n<div class="shop-location-map-item-main">${highlightTag}<strong title="${escapeHtml(displayName)}">${escapeHtml(displayName)}</strong><br><small>${escapeHtml(l.address || "")}</small></div>${openLink}\n</li>`;
        })
        .join("");

      listEl
        .querySelectorAll(".shop-location-map-list-item")
        .forEach((item) => {
          item.addEventListener("click", () => {
            const loc = findLocation(item);
            focusLocation(loc, false); // focus only, no redirect
          });
          item.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              const loc = findLocation(item);
              focusLocation(loc, false);
            }
          });
        });

      listEl.querySelectorAll(".shop-location-map-open").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          const id = btn.getAttribute("data-open-id");
          const loc = locations.find((l) => String(l.id) === String(id)) || {};
          const url = hasUrl(loc) ? loc.url : "#";
          if (url && url !== "#") {
            window.location.href = url;
          }
        });
      });

      // Add show more / close button for mobile (only if more than 5 items)
      updateToggleButton(subset.length);
    }

    function updateToggleButton(totalItems) {
      // Remove existing button if any
      const existingBtn = wrapper.querySelector('.shop-location-map-toggle-btn');
      if (existingBtn) existingBtn.remove();

      // Only show button if there are more than 5 items
      if (totalItems <= 5) {
        listEl.parentElement.classList.remove('is-collapsed');
        return;
      }

      // Create toggle button
      const toggleBtn = document.createElement('button');
      toggleBtn.className = 'shop-location-map-toggle-btn';
      toggleBtn.setAttribute('type', 'button');
      toggleBtn.setAttribute('aria-expanded', 'false');

      // Initially collapsed - show first 5
      listEl.parentElement.classList.add('is-collapsed');
      toggleBtn.textContent = `もっと見る (${totalItems}店舗)`;

      // Toggle functionality
      toggleBtn.addEventListener('click', () => {
        const isCollapsed = listEl.parentElement.classList.contains('is-collapsed');
        if (isCollapsed) {
          // Expand - show all
          listEl.parentElement.classList.remove('is-collapsed');
          toggleBtn.textContent = '閉じる';
          toggleBtn.setAttribute('aria-expanded', 'true');
          // Move button to bottom when expanded
          listEl.parentElement.appendChild(toggleBtn);
        } else {
          // Collapse - show first 5
          listEl.parentElement.classList.add('is-collapsed');
          toggleBtn.textContent = `もっと見る (${totalItems}店舗)`;
          toggleBtn.setAttribute('aria-expanded', 'false');
          // Move button back to after list wrapper
          listEl.parentElement.parentElement.insertBefore(toggleBtn, listEl.parentElement.nextSibling);
          // Scroll back to top of list
          listEl.parentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      // Insert button after the list wrapper initially
      listEl.parentElement.parentElement.insertBefore(toggleBtn, listEl.parentElement.nextSibling);
    }

    function renderMarkers() {
      markers.forEach((m) => m.setMap(null));
      markers = [];
      const subset = grouped[activePref] || [];
      const valid = subset.filter(hasValidLatLng);
      if (!valid.length) return;
      const bounds = new google.maps.LatLngBounds();
      valid.forEach((loc) => {
        const marker = createMarkerOverlay(loc);
        markers.push(marker);
        bounds.extend(marker.position);
      });
      if (subset.length > 1) {
        map.fitBounds(bounds);
      } else {
        map.setCenter({ lat: +subset[0].lat, lng: +subset[0].lng });
        map.setZoom(13);
      }
    }

    function createMarkerOverlay(loc) {
      const position = new google.maps.LatLng(+loc.lat, +loc.lng);
      const markerStyle = getMarkerStyle(loc);
      
      class MarkerOverlay extends google.maps.OverlayView {
        constructor() {
          super();
          this.loc = loc;
          this.position = position;
          this.markerStyle = markerStyle;
          this.div = null;
          this.setMap(map);
        }
        onAdd() {
          this.div = document.createElement("div");
          this.div.className = "shop-location-map-marker";
          this.div.setAttribute("role", "button");
          this.div.setAttribute("tabindex", "0");
          const displayName = loc.displayName || loc.name || "";
          if (displayName) {
            this.div.setAttribute("aria-label", displayName);
          }
          
          if (this.markerStyle.type === "image") {
            this.div.classList.add("has-image");
            const img = document.createElement("img");
            img.src = this.markerStyle.url;
            img.alt = "";
            img.decoding = "async";
            img.loading = "lazy";
            this.div.appendChild(img);
          } else {
            // Color pin
            this.div.style.setProperty("--marker-color", this.markerStyle.color);
            const pin = document.createElement("span");
            pin.className = "marker-pin";
            this.div.appendChild(pin);
          }
          
          const handleClick = () => {
            focusLocation(loc, false);
            if (tooltipOverlay) {
              tooltipOverlay.show(loc, position);
              if (IS_TOUCH && tooltipOverlay.arm) {
                tooltipOverlay.arm();
              }
            }
          };
          const handleOver = () => {
            if (tooltipOverlay) tooltipOverlay.show(loc, position);
          };
          const handleOut = () => {
            if (tooltipOverlay) tooltipOverlay.scheduleHide();
          };
          const handleKeydown = (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleClick();
            }
          };
          this.div.addEventListener("click", handleClick);
          this.div.addEventListener("mouseenter", handleOver);
          this.div.addEventListener("mouseleave", handleOut);
          this.div.addEventListener("keydown", handleKeydown);
          this.getPanes().overlayMouseTarget.appendChild(this.div);
        }
        draw() {
          if (!this.div) return;
          const proj = this.getProjection();
          if (!proj) return;
          const point = proj.fromLatLngToDivPixel(this.position);
          if (point) {
            this.div.style.left = point.x + "px";
            this.div.style.top = point.y + "px";
          }
        }
        onRemove() {
          if (this.div && this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
          }
          this.div = null;
        }
      }
      return new MarkerOverlay();
    }

    function focusLocation(loc, fromUser) {
      if (!loc) return;
      activePref = loc.prefecture;
      if (prefectureSelect.value !== activePref)
        prefectureSelect.value = activePref;
      if (map && hasValidLatLng(loc)) {
        // Smooth pan to location
        map.panTo({ lat: +loc.lat, lng: +loc.lng });
        
        // Smooth zoom animation
        const targetZoom = 15;
        const currentZoom = map.getZoom();
        
        if (currentZoom !== targetZoom) {
          // Animate zoom smoothly over time
          const zoomDiff = targetZoom - currentZoom;
          const steps = Math.abs(zoomDiff) * 2; // More steps for smoother animation
          const stepSize = zoomDiff / steps;
          let currentStep = 0;
          
          const zoomInterval = setInterval(() => {
            currentStep++;
            const newZoom = currentZoom + (stepSize * currentStep);
            
            if (currentStep >= steps) {
              map.setZoom(targetZoom);
              clearInterval(zoomInterval);
            } else {
              map.setZoom(newZoom);
            }
          }, 50); // 50ms intervals for smooth animation
        }
        
        // On mobile, scroll to show the map area when clicking from list
        if (window.innerWidth <= 600) {
          setTimeout(() => {
            mapContainer.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'center' 
            });
          }, 100); // Small delay to let map animation start
        }
      }
      activeLocationId = loc.id;
      highlightList();
      if (fromUser) updateURL(loc);
    }

    function highlightList() {
      let activeEl = null;
      listEl.querySelectorAll(".shop-location-map-list-item").forEach((el) => {
        const isActive =
          el.getAttribute("data-location-id") == activeLocationId;
        el.classList.toggle("is-active", isActive);
        if (isActive) activeEl = el;
      });
      if (activeEl) {
        activeEl.scrollIntoView({ block: "nearest", behavior: "smooth" });
      }
    }

    function updateURL(loc) {
      // Only update URL parameters for primary section (shop-location page)
      if (!isPrimarySection) return;
      
      const params = new URLSearchParams(window.location.search);
      params.set("pref", activePref);
      if (loc) params.set("loc", loc.slug);
      else params.delete("loc");
      const newUrl = `${shareBase}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }

    function firstLocationOf(pref) {
      return (grouped[pref] || [])[0];
    }

    function findLocation(item) {
      const id = item.getAttribute("data-location-id");
      return locations.find((l) => String(l.id) === String(id));
    }
  }

  function parseCsv(raw) {
    const lines = String(raw || "")
      .replace(/\r\n/g, '\n')  // Normalize line endings
      .replace(/\r/g, '\n')    // Handle old Mac format
      .trim()
      .split('\n')
      .filter((l) => l.trim() !== "");
    if (!lines.length) return [];
    const headers = splitCsvRow(lines[0]).map((h) => normalizeHeaderKey(h));
    const rows = [];
    lines.slice(1).forEach((line, idx) => {
      if (!line.trim()) return;
      const cells = splitCsvRow(line);
      const get = (keys) => {
        const list = Array.isArray(keys) ? keys : [keys];
        for (const key of list) {
          const pos = headers.indexOf(normalizeHeaderKey(key));
          if (pos !== -1 && typeof cells[pos] !== "undefined") {
            return cells[pos];
          }
        }
        return "";
      };
      
      // Auto-generate ID if missing or empty
      let id = get(["id", "#"]) || (idx + 1).toString();
      
      const entry = {
        id: id,
        company: get(["company", "企業名"]),
        name: get(["name", "店舗名", "店名"]),
        address: get(["address", "住所"]),
        prefecture: get(["prefecture", "pref", "都道府県", "県"]),
        pref: get(["prefecture", "pref", "都道府県", "県"]),
        lat: get("lat"),
        lng: get(["lng", "lon", "longitude"]),
        url: get(["url", "店舗url"]),
        postal: get(["postal", "郵便番号"]),
        hours: get(["hours", "営業時間"]),
        // Updated key names for marker URL/image
        // Change or add any keys here as needed for compatibility
        marker_url: get([
          "marker_url",
          "marker",
          "image",
          "image_url",
          "icon",
          "pin",
          "ピン画像",
          "ピンURL",
          "ピンurl",
          "マーカー",
          "マーカー画像",
          "マーカーURL",
        ]),
      };
      rows.push(entry);
    });
    return rows;
  }

  function splitCsvRow(row) {
     // Handle both comma and tab delimiters
    const delimiter = row.includes('\t') ? '\t' : ',';
    const result = [];
    let current = "";
    let inQuotes = false;
    for (let i = 0; i < row.length; i++) {
      const ch = row[i];
      if (ch === '"' && row[i + 1] === '"') {
        current += '"';
        i++;
      } else if (ch === '"') {
        inQuotes = !inQuotes;
      } else if (ch === delimiter && !inQuotes) {
        result.push(current.trim());
        current = "";
      } else {
        current += ch;
      }
    }
    result.push(current.trim());
    return result;
  }

  function normalizeHeaderKey(header) {
    if (!header) return "";
    const cleaned = header.replace(/^\uFEFF/, "").trim().toLowerCase();
    const map = {
      "#": "id",
      id: "id",
      "識別子": "id",
      company: "company",
      "企業名": "company",
      name: "name",
      "店舗名": "name",
      "店名": "name",
      address: "address",
      "住所": "address",
      pref: "prefecture",
      prefecture: "prefecture",
      "都道府県": "prefecture",
      "県": "prefecture",
      lat: "lat",
      latitude: "lat",
      "緯度": "lat",
      lng: "lng",
      lon: "lng",
      longitude: "lng",
      "経度": "lng",
      url: "url",
      "店舗url": "url",
      "url": "url",
      postal: "postal",
      "郵便番号": "postal",
      hours: "hours",
      "営業時間": "hours",
      // Updated key names for marker URL/image
      // Change or add any keys here as needed for compatibility
      marker: "marker_url",
      marker_url: "marker_url",
      "marker url": "marker_url",
      image: "marker_url",
      image_url: "marker_url",
      "image url": "marker_url",
      icon: "marker_url",
      pin: "marker_url",
      "ピン画像": "marker_url",
      "ピンurl": "marker_url",
      "ピンURL": "marker_url",
      "マーカー": "marker_url",
      "マーカー画像": "marker_url",
      "マーカーURL": "marker_url",
    };
    return map[cleaned] || cleaned;
  }

  function groupBy(arr, key) {
    return arr.reduce((acc, it) => {
      const k = it[key];
      (acc[k] = acc[k] || []).push(it);
      return acc;
    }, {});
  }

  function slugify(str) {
    return String(str || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9一-龠ぁ-んァ-ヶー]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function escapeHtml(str) {
    return String(str).replace(
      /[&<>"']/g,
      (s) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        })[s] || s
    );
  }

  function hashString(str) {
    let hash = 0;
    const input = String(str || "");
    for (let i = 0; i < input.length; i++) {
      hash = (hash * 31 + input.charCodeAt(i)) >>> 0;
    }
    return hash;
  }

  function populatePrefectureSelect(select, prefs, initial, labelMap = {}) {
    const opts = [
      '<option value="" selected>都道府県を選択してください</option>',
    ].concat(
      prefs.map((p) => {
        const label = labelMap[p] || p;
        return `<option value="${p}" ${p === initial ? "selected" : ""}>${label}</option>`;
      })
    );
    select.innerHTML = opts.join("");
  }

  function buildPrefectureLabels(locs) {
    const map = {};
    locs.forEach((loc) => {
      const slug = loc && loc.prefecture;
      const label =
        loc.prefecture_label ||
        loc.pref ||
        loc["都道府県"] ||
        loc.prefecture;
      if (slug && label && !map[slug]) {
        map[slug] = label;
      }
    });
    return map;
  }

  function hasValidLatLng(loc) {
    const lat = Number(loc && loc.lat);
    const lng = Number(loc && loc.lng);
    return Number.isFinite(lat) && Number.isFinite(lng);
  }

  function hasUrl(loc) {
    const url = loc && loc.url;
    return Boolean(url && url !== "#");
  }
  // Custom tooltip overlay class (single instance per map)
  function createTooltipOverlay(map) {
    class Tooltip extends google.maps.OverlayView {
      constructor() {
        super();
        this.div = null;
        this.position = null;
        this.loc = null;
        this.visible = false;
        this.needsPositionUpdate = false;
        this.hideTimer = null;
        this._armed = false; // for double-tap on touch
        this._disarmTimer = null;
      }
      onAdd() {
        this.div = document.createElement("div");
        this.div.className = "shop-location-map-tooltip hidden";
        this.div.setAttribute("role", "button");
        this.div.setAttribute("tabindex", "0");
        this.getPanes().floatPane.appendChild(this.div);
        this.div.addEventListener("mouseenter", () => {
          if (this.hideTimer) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
          }
        });
        this.div.addEventListener("mouseleave", () => {
          this.scheduleHide(120);
        });
        this.div.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            if (this.loc && hasUrl(this.loc)) {
              if (!IS_TOUCH) {
                window.location.href = this.loc.url;
              } else {
                if (!this._armed) {
                  this.arm();
                } else {
                  window.location.href = this.loc.url;
                }
              }
            }
          }
        });
      }
      draw() {
        if (!this.visible || !this.position) return;
        const proj = this.getProjection();
        if (!proj) return;
        const point = proj.fromLatLngToDivPixel(this.position);
        if (point && this.div) {
          this.div.style.left = point.x + "px";
          this.div.style.top = point.y + "px";
        }
      }
      onRemove() {
        if (this.div && this.div.parentNode)
          this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
      show(loc, latLng) {
        const changed = !this.loc || (this.loc && this.loc.id !== loc.id);
        this.loc = loc;
        this.position = latLng;
        this.visible = true;
        if (changed) this._armed = false; // reset arm when switching targets
        if (this.div) {
          const displayName = loc.displayName || loc.name || "";
          const safeName = escapeHtml(displayName);
          this.div.innerHTML = `<span>${safeName} &gt;</span>`;
          if (hasUrl(loc)) {
            this.div.classList.add("has-url");
            this.div.onclick = (e) => {
              if (!IS_TOUCH) {
                window.location.href = loc.url;
                return;
              }
              // Touch: require two taps within timeout
              if (!this._armed) {
                e.preventDefault();
                this.arm();
              } else {
                window.location.href = loc.url;
              }
            };
            this.div.setAttribute("aria-label", safeName + " – open location");
          } else {
            this.div.classList.remove("has-url");
            this.div.onclick = null;
            this.div.setAttribute("aria-label", safeName);
          }
          this.div.classList.remove("hidden");
        }
        this.draw();
      }
      hide() {
        this.visible = false;
        if (this.div) {
          this.div.classList.add("hidden");
          this.div.onclick = null;
          this.disarm();
        }
      }
      scheduleHide(delay = 80) {
        if (this.hideTimer) clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => this.hide(), delay);
      }
      updatePosition() {
        if (this.visible) this.draw();
      }
      arm() {
        this._armed = true;
        clearTimeout(this._disarmTimer);
        this._disarmTimer = setTimeout(() => {
          this._armed = false;
        }, 3500);
      }
      disarm() {
        this._armed = false;
        clearTimeout(this._disarmTimer);
      }
    }
    const overlay = new Tooltip();
    overlay.setMap(map);
    return overlay;
  }

  function prefectureKey(label) {
    const map = {
      "東京都": "tokyo",
      tokyo: "tokyo",
      "大阪府": "osaka",
      osaka: "osaka",
      "愛知県": "aichi",
      aichi: "aichi",
      "北海道": "hokkaido",
      hokkaido: "hokkaido",
      "福岡県": "fukuoka",
      fukuoka: "fukuoka",
    };
    return map[label] || slugify(label);
  }

  function prefectureLabel(label) {
    const map = {
      tokyo: "東京都",
      osaka: "大阪府",
      aichi: "愛知県",
      hokkaido: "北海道",
      fukuoka: "福岡県",
    };
    return map[label] || label;
  }

  // Note* Location data may come in various formats; normalize to expected keys.
  function normalizeLocation(src, idx) {
    const mapped = { ...src };
    if (!mapped.name && src["店舗名"]) mapped.name = src["店舗名"];
    if (!mapped.name && src["店名"]) mapped.name = src["店名"];
    if (!mapped.company && src["企業名"]) mapped.company = src["企業名"];
    if (!mapped.address && src["住所"]) mapped.address = src["住所"];
    if (!mapped.url && src["店舗URL"]) mapped.url = src["店舗URL"];
    if (!mapped.postal && src["郵便番号"]) mapped.postal = src["郵便番号"];
    if (!mapped.hours && src["営業時間"]) mapped.hours = src["営業時間"];
    if (!mapped.lat && src["住所の経度緯度"]) {
      if (typeof src["住所の経度緯度"].lat !== "undefined")
        mapped.lat = src["住所の経度緯度"].lat;
      if (typeof src["住所の経度緯度"].lng !== "undefined")
        mapped.lng = src["住所の経度緯度"].lng;
    }
    
    let prefLabel =
      mapped.prefecture_label ||
      src.pref ||
      mapped.pref ||
      src.prefecture ||
      src["都道府県"] ||
      src["県"] ||
      mapped.prefecture;
    
    // Auto-extract prefecture from address if not provided
    if (!prefLabel && mapped.address) {
      const prefectures = [
        "北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県",
        "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県",
        "新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県",
        "静岡県", "愛知県", "三重県", "滋賀県", "京都府", "大阪府", "兵庫県",
        "奈良県", "和歌山県", "鳥取県", "島根県", "岡山県", "広島県", "山口県",
        "徳島県", "香川県", "愛媛県", "高知県", "福岡県", "佐賀県", "長崎県",
        "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県"
      ];
      
      for (const pref of prefectures) {
        if (mapped.address.includes(pref)) {
          prefLabel = pref;
          break;
        }
      }
    }
    
    if (!mapped.prefecture_label && prefLabel)
      mapped.prefecture_label = prefLabel;
    if (prefLabel) {
      mapped.prefecture = prefectureKey(prefLabel);
      mapped.prefecture_label = prefectureLabel(prefLabel);
    }
    if (!mapped.id) mapped.id = src.id || src["#"] || (idx + 1).toString();
    if (!mapped.url) mapped.url = "#";
    if (!mapped.hours) mapped.hours = "Open";
    
    // Merge company name with store name for display if both exist
    if (mapped.company && mapped.name && mapped.company !== mapped.name) {
      mapped.displayName = `${mapped.company} ${mapped.name}`;
    } else {
      mapped.displayName = mapped.name || mapped.company || "";
    }
    
    if (typeof mapped.lat === "string") {
      const lat = parseFloat(mapped.lat);
      if (!Number.isNaN(lat)) mapped.lat = lat;
    }
    if (typeof mapped.lng === "string") {
      const lng = parseFloat(mapped.lng);
      if (!Number.isNaN(lng)) mapped.lng = lng;
    }
    return mapped;
  }

})();
